// extracted by mini-css-extract-plugin
export default {"container":"EstimateTemplateDiscounts_container__n2YIY","item":"EstimateTemplateDiscounts_item__824nK","closeField":"EstimateTemplateDiscounts_closeField__ce5ns"};